import { Injectable } from '@angular/core';
import {
  AddPreferredLocationGQL,
  DeletePreferredLocationGQL,
  SearchLocationsGQL,
  UpdateProfileResponse
} from '@cpd-app/generated';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Location } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class PreferredLocationService {
  constructor(
    private addPreferredLocationGQL: AddPreferredLocationGQL,
    private deletePreferredLocationGQL: DeletePreferredLocationGQL,
    private searchLocationsGQL: SearchLocationsGQL
  ) {}

  public searchLocations(searchString: string): Observable<Location[]> {
    return this.searchLocationsGQL.fetch({ searchTerm: searchString }).pipe(
      map((results) => {
        return results?.data?.searchLocations.map((l) => {
          return {
            fipsCode: l.countyFipsCode,
            lat: l.latitude,
            lon: l.longitude,
            name: l.cityName,
            zipCode: l.zipCode
          };
        });
      })
    );
  }

  public putPreferredLocation(
    preferredLocation: Location
  ): Observable<UpdateProfileResponse> {
    return this.addPreferredLocationGQL
      .mutate({ location: preferredLocation })
      .pipe(
        map((result) => {
          return result.data.addPreferredLocation;
        })
      );
  }

  public deletePreferredLocation(
    preferredLocation
  ): Observable<UpdateProfileResponse> {
    const locationDetails = {
      fipsCode: parseInt(preferredLocation.fipsCode),
      name: preferredLocation.name,
      lat: preferredLocation.lat,
      lon: preferredLocation.lon,
      zipCode: preferredLocation.zipCode
    };
    return this.deletePreferredLocationGQL
      .mutate({ location: locationDetails })
      .pipe(
        map((result) => {
          return result.data.deletePreferredLocation;
        })
      );
  }
}
